module.exports = __webpack_public_path__ + "static/img/科协优秀奖.f93dc440.jpg";